import React from 'react'
import * as C from "../componentsM/index";

const OurValue = () => {
    return (
        <>


            <C.Hero title={"CORE VALUES"}
                tagLine={"The Values Which Define Our Functions In Achieving Our Mission And Objectives"}
                image={"/hero/value.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <h1>The Values Which Define Our Functions In Achieving Our mission and objectives are:</h1>


                    <ul className="list-disc list-inside my-2">
                        {[
                            "honesty",
                            "compassion",
                            "justice",
                            "unity",
                            "belief",
                            "discipline",
                            "resilience",
                            "open-minded",
                            "inquisitive",
                            "optimistic"
                        ]
                            .map(v => <li key={v} className='my-2 font-semibold'>{v}</li>)}
                    </ul>

                </div>



            </section>
        </>
    )
}

export default OurValue